import { useState } from "react";
import { useLang } from "../context/LanguageContext";
import { useData } from "../context/DataContext";
import { SocialIcon, SOCIAL_META } from "./Social";

export default function Hero() {
  const { lang, t } = useLang();
  const { profile } = useData();
  const [imgFailed, setImgFailed] = useState(false);

  const links = [
    { key: "cv", label: t.hero.viewCv, href: profile.links.cv },
    {
      key: "email",
      label: t.hero.email,
      href: `mailto:${profile.email.replace("[at]", "@")}`,
    },
  ].filter((l) => l.href && l.href.length > 0);

  const socialItems = SOCIAL_META.filter(
    (m) => profile.links[m.key] && profile.links[m.key].length > 0
  );

  return (
    <section id="about" className="hero">
      <div className="hero__inner">
        <div className="hero__text">
          <p className="hero__eyebrow">{profile.title[lang]}</p>
          <h1 className="hero__name">{profile.name[lang]}</h1>
          <div className="hero__affiliation">
            {profile.affiliation[lang].map((line, i) => {
              if (typeof line === "object" && line.link) {
                return (
                  <a
                    key={i}
                    href={line.link}
                    className="hero__affiliation-link"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {line.text}
                    <span
                      aria-hidden="true"
                      className="hero__affiliation-arrow"
                    >
                      ↗
                    </span>
                  </a>
                );
              }
              return (
                <span key={i}>
                  {typeof line === "string" ? line : line.text}
                </span>
              );
            })}
          </div>
          <p className="hero__about">{profile.about[lang]}</p>

          {(links.length > 0 || socialItems.length > 0) && (
            <ul className="hero__links">
              {links.map((l) => (
                <li key={l.key}>
                  <a
                    href={l.href}
                    className="hero__link"
                    target={l.href.startsWith("mailto:") ? undefined : "_blank"}
                    rel="noreferrer"
                  >
                    {l.label}
                    <span className="hero__link-arrow" aria-hidden="true">
                      ↗
                    </span>
                  </a>
                </li>
              ))}
              {socialItems.map((m, i) => (
                <li
                  key={m.key}
                  className={i === 0 ? "hero__social-first" : undefined}
                >
                  <a
                    href={profile.links[m.key]}
                    className="hero__social"
                    target="_blank"
                    rel="noreferrer"
                    aria-label={m.label}
                    title={m.label}
                  >
                    <SocialIcon kind={m.key} />
                  </a>
                </li>
              ))}
            </ul>
          )}
        </div>

        <div className="hero__portrait">
          {imgFailed ? (
            <div className="hero__portrait-fallback" aria-hidden="true">
              YN
            </div>
          ) : (
            <img
              src={profile.profileImage}
              alt={profile.name.en}
              loading="eager"
              onError={() => setImgFailed(true)}
            />
          )}
        </div>
      </div>
    </section>
  );
}
